import QueryWhereLeftBracket from '../../../query/remote/QueryWhereLeftBracket';
import QueryWhereRightBracket from '../../../query/remote/QueryWhereRightBracket';
import StringUtil from '../../../utils/StringUtil';

//CMD Job
export default class RecordConditionTask
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.RecordConditionTask";
	isNull;
	recordCondition;
	trueCommandResult;
	falseCommandResult;
	
	_sqlWhereStr = null;
	
	static getSqlWhereStr()
	{
		//默认为undifined 经过计算也有可能未""所以要单独判断
	    if(this._sqlWhereStr == "" || this._sqlWhereStr)
	      return this._sqlWhereStr;
	    var i = 0;
	    var result = "";
	    var leftBracket = QueryWhereLeftBracket.None;
	    var rightBracket = QueryWhereRightBracket.None;
	    for(i=0;i<this.recordCondition.items.length;i++)
	    {
	      let item = this.recordCondition.items[i];
	      if(item.fieldName.indexOf(".") != 0 && item.fieldName.indexOf("@") != 0)
	        item.fieldName = "."+item.fieldName;
	      if(i > 0)
	      {
	        //result += (" " + QueryWhereAndOr.labelOf(item.andOr));
	        result += (" " + item.andOr);
	      }
	      
	      
	      if(item.leftBracket!=QueryWhereLeftBracket.None)
	      {
	        result += (" " + QueryWhereLeftBracket.labelOf(item.leftBracket));
	        leftBracket += item.leftBracket;
	      }
	      
	      if(item.fieldValue == null)
	        item.fieldValue = "";
	      
	      if(item.fieldValue.indexOf(",") != -1)
	        var fieldValues = item.fieldValue.split(",");
	      else
	        fieldValues = [item.fieldValue];
	      
	      if(fieldValues.length > 1)
	        result += " (";
	      
	      var j = 0;
	      for(j=0;j<fieldValues.length;j++)
	      {
	        let _fv = fieldValues[j];
	        if(j > 0)
	        {
	          result += (" or " + item.fieldName+"="+StringUtil.trimThrough(_fv));  
	        }
	        else
	        {
	          result += (" "+item.fieldName+"="+StringUtil.trimThrough(_fv));
	        }
	      }
	      
	      if(fieldValues.length > 1)
	        result += " )";
	      
	      if(item.rightBracket!=QueryWhereRightBracket.None)
	      {
	        result += (" " + QueryWhereRightBracket.labelOf(item.rightBracket));
	        rightBracket += item.rightBracket;
	      }
	    }
	    
	    if(leftBracket != rightBracket)
	    {
	      //GongqiAlert.show("括号不匹配");
	      return "";
	    }
	    
	    this._sqlWhereStr = result;
	    return result;
	}
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/RecordConditionTask.js